import { InputRegex } from '@forms/form-text-input/entities/input-mask';

const STRICT_STRIP_REGEX = /[.-]/g;
const LOOSE_STRIP_REGEX = /[^\d]/g;

export function isValidPeruRUC(number: string, strict?: boolean): boolean {
  const stripped: string = strip(number, strict);
  if (!stripped) return false;
  if (stripped.length !== 11) return false;
  if (isNaN(Number(stripped))) return false;
  if (!new RegExp(InputRegex.RUC_PE).test(stripped)) return false;
  let sum = 0;
  let x = 6;
  for (let i = 0; i < stripped.length - 1; i++) {
    if (i === 4) x = 8;
    const digito = Number(stripped.charAt(i));
    x--;
    if (i === 0) sum += (digito * x);
    else sum += (digito * x);
  }
  let rest = sum % 11;
  rest = 11 - rest;
  if (rest >= 10) rest = rest - 10;
  if (rest === Number(stripped.charAt(stripped.length - 1))) {
    return true;
  }
}

function strip(number: string, strict?: boolean): string {
  const regex: RegExp = strict ? STRICT_STRIP_REGEX : LOOSE_STRIP_REGEX;
  return (number || '').replace(regex, '');
}
